import React from 'react';
import { 
  useOutlet 
} from 'react-router-dom';
import { 
  EpDevPSearchContextProvider,
} from '../context';

// export const UrlUpdater = () => {
//   const location = useLocation();
//   const epDevPSearchContextValue: EpDevPSearchContextValue = useEpDevPSearch();
//   const prevQueryParams = usePrevious(location.search);
  
//   React.useEffect(() => {
//     // Only respond to changes to url query params
//     if (location.search === prevQueryParams) return;
//     const query = qs.parse(location.search.substring(1), { arrayLimit: 0 }) || {};

//     const logName = 'EpDevPSearchPage.useEffect()';
//     console.log(`${logName}: query=${JSON.stringify(query, null, 2)}`);
//     console.log(`${logName}: epDevPSearchContextValue=${JSON.stringify(epDevPSearchContextValue, null, 2)}`);
    
//     // alert(`${logName} - check out the query object and parse appropriately`)

//     // // IEpDevPSearchListQueryParams
//     // // - filters.backstageFilters?: JsonObject; 
//     // if(query.filters === undefined) return;
//     // if(query.filters.backstageFilters) {
//     //   setFilters(query.filters as JsonObject);
//     // }

//     // if (query.query) {
//     //   setTerm(query.query as string);
//     // }

//     // if (query.pageCursor) {
//     //   setPageCursor(query.pageCursor as string);
//     // }

//     // if (query.types) {
//     //   setTypes(query.types as string[]);
//     // }
//   // }, [prevQueryParams, location, setTerm, setTypes, setPageCursor, setFilters]);
// }, [prevQueryParams, location]);

//   // useEffect(() => {
//   //   const newParams = qs.stringify(
//   //     {
//   //       query: term,
//   //       types,
//   //       pageCursor,
//   //       filters,
//   //     },
//   //     { arrayFormat: 'brackets' },
//   //   );
//   //   const newUrl = `${window.location.pathname}?${newParams}`;

//   //   // We directly manipulate window history here in order to not re-render
//   //   // infinitely (state => location => state => etc). The intention of this
//   //   // code is just to ensure the right query/filters are loaded when a user
//   //   // clicks the "back" button after clicking a result.
//   //   window.history.replaceState(null, document.title, newUrl);
//   // }, [term, types, pageCursor, filters]);

//   return null;
// };


export const EpDevPSearchPage = () => {
  const outlet = useOutlet();
  return (
    <EpDevPSearchContextProvider>
      {/* <UrlUpdater /> */}
      {outlet}
    </EpDevPSearchContextProvider>
  );
};
